function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function RefreshPhone({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 1c1.103 0 2 .897 2 2v2.21a5.977 5.977 0 013.405.718l.97-.97a.5.5 0 01.846.263l.757 4.141a.5.5 0 01-.582.582l-4.14-.758a.5.5 0 01-.264-.845l.907-.908a4.013 4.013 0 00-5.391 3.763 4.013 4.013 0 004.008 4.008 3.986 3.986 0 003.436-1.94 1 1 0 111.711 1.033 5.964 5.964 0 01-5.147 2.907 6.06 6.06 0 01-.516-.022V21c0 1.103-.897 2-2 2H4c-1.103 0-2-.897-2-2V3c0-1.103.897-2 2-2h10.5zm0 17.394H4V21h10.5v-2.606zm-5.298.358a.951.951 0 110 1.903.951.951 0 010-1.903zm4.238-12.38H4v10.022l10.008.002a6.004 6.004 0 01-.568-10.024zM14.5 3H4v1.371h10.5v-1.37z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}

const MemoRefreshPhone = React.memo(RefreshPhone);
export default MemoRefreshPhone;